<template>
<div>
    <!-- modal -->
    <b-modal id="statementEditFormModal" centered size="lg" no-close-on-backdrop ref="statementEditFormModal" :title=" $t('statement.info')" hide-footer>
        <div class="custom-search d-flex justify-content-end">
            <b-row>
                <b-col>
                    <b-button variant="outline-primary" size="sm" @click.prevent="addOrUpdate">
                        {{ $t('others.ok_title') }}
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <b-row>
            <b-col class="col-lg-12 mt-1 mb-1">
                <label for="statement-amount-input">{{ $t('statement.amount') }}</label>
                <validation-provider :name="$t('statement.amount')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                    <cleave id="statement-amount-input" v-model="amount" class="cleaveStyle form-control" :options="cleaveOptions" :state="errors.length > 0 ? false : null"></cleave>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-lg-12 mt-1 mb-1">
                <label class="mt-1" for="statement-description-input">{{ $t('statement.description') }}</label>
                <b-form-textarea id="statement-description-input" :placeholder=" $t('statement.description')" rows="3" v-model="description" />
            </b-col>
        </b-row>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getStatementList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            description: '',
            amount: 0,
            cleaveOptions: {
                prefix: '',
                numeral: true,
                numeralPositiveOnly: true,
                noImmediatePrefix: true,
                rawValueTrimPrefix: true,
                numeralIntegerScale: 9,
                numeralDecimalScale: 2
            },
        }
    },
    methods: {
        showInfo(id) {
            this.$refs['statementEditFormModal'].show()
            this.id = id
            if (this.id == 0)
                this.hiddenControl = true
            else this.hiddenControl = false
            const data = {
                id: this.id
            }
            const controller = {
                name: 'InvoiceStatement'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.description = response.data.invoiceStatement.description
                    this.amount = response.data.invoiceStatement.amount
                } else {
                    this.$bvModal.hide('statementEditFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                invoiceStatementId: this.id,
                description: this.description,
                amount: this.amount
            }
            const controller = {
                name: 'InvoiceStatement',
                actionName: 'UpdateInvoiceStatement'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$bvModal.hide('statementEditFormModal')
                    this.getStatementList()
                    this.$SaveAlert()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
